import { motion } from "framer-motion";
import React from "react";
import { Button } from "react-bootstrap";

const pageTransition = {
  empty: { opacity: 0, y: "100vh" },
  entry: { opacity: 1, y: 0, transition: { delay: 1, type: "skew" } },
  exit: { x: "-100vw", transition: "easeInOut" },
};

const NotFound = () => {
  return (
    <motion.div
      className="overflow-x-hidden"
      variants={pageTransition}
      initial="empty"
      animate="entry"
      exit="exit"
    >
      <div className="bg-dark p-5 fixed-top"></div>
      <div className="min-vh-100 d-flex align-items-center bg-dark justify-content-center">
        <div className="p-5 rounded text-center">
          <img src="/404.svg" alt="404" className="imgadapt" />
          <h1 className="display-5 text-uppercase text-white fw-bold text-center mx-5">
            Page Not Found
          </h1>
          <p className="text-center text-white fs-4">
            Houston, we've lost the page
          </p>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => window.history.back()}
          >
            Head back to my world
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

export default NotFound;
